import * as React from "react";
import NumberUtils from "../../../../utils/NumberUtils";

interface IProps {
	value: number;
}

export const PercentagePresenter: React.SFC<IProps> = (props) => {
	return (
		<span>{NumberUtils.roundToMaxTwoDecimals(props.value)}%</span>
	);
};
